@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Email Template
      </h3></div>
      <div class="surface-card p-4 shadow-2 border-round cf-col" style="width: 50%; float:left;">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Template Name</label>
            <input [(ngModel)]="emailtemplate.name" id="classname" type="text" [ngStyle]="{'border-color': (emailtemplateNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
          </div>
          @if (!emailtemplateNameValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Email Template name.</div>
          }
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Email Subject</label>
            <input [(ngModel)]="emailtemplate.emailsubject" id="classname" type="text" [ngStyle]="{'border-color': (subjectValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
          </div>
          @if (!subjectValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Subject.</div>
          }
          <!-- On a phone the fields cannot be dragged in, so they are inserted from here at
          the cursor - see insertField. -->
          @if (isMobile) {
            <div class="field mb-2 col-12">
              <label class="font-medium">Insert a field</label>
              <div class="cf-add-row" style="margin-bottom: 0;">
                <p-select [options]="ContArray" [(ngModel)]="fieldToInsert" optionLabel="fieldname" placeholder="Choose a field"
                [filter]="true" filterBy="fieldname" appendTo="body"></p-select>
                <button pButton pRipple type="button" class="p-button-info"
                  [disabled]="fieldToInsert == null" (click)="insertField()"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Insert</span></button>
                </div>
                <small class="block mt-1" style="color:#6c757d;">Tap in the message where the field should go, then choose it and press Insert.</small>
              </div>
            }
            <div class="field mb-4 col-12">
              <p-editor [(ngModel)]="emailtemplate.message" [style]="{'height':'320px'}" (onInit)="editorReady($event)">
                <ng-template #header>
                  <span class="ql-formats">
                    <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="small">Small</option>
                          <option selected value="normal">Normal</option>
                          <option value="large">Sub Heading</option>
                          <option value="huge">Heading</option>
                        </select>
                        <select class="ql-font">
                          <option selected value="san serif">San-Serif</option>
                          <option value="monospace">Monospace</option>
                          <option value="serif">Serif</option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                        <button class="ql-script" value="sub" title="Subscript"></button>
                        <button class="ql-script" value="super" title="Superscript"></button>
                        <button class="ql-indent" value="-1" title="Indent"></button>
                        <button class="ql-indent" value="+1" title="Outdent"></button>
                      </span>
                      <span class="ql-formats">
                        <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                        </select>
                        <span class="ql-format-separator"></span>
                        <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-list" title="Ordered" value="ordered"></button>
                        <button class="ql-list" title="Bullet" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align" >
                          <option label="Left"></option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                      </span>
                    </p-header>
                  </span>
                </ng-template>
              </p-editor>
            </div>
            @if (!emailtemplateMessageValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Email Template message.</div>
            }
            <div class="field mb-4 col-12">
              <label for="venueclosingstartdate">Payment message</label>
              <p-selectbutton class="cf-stack" [options]="PaymentMessage" [(ngModel)]="emailtemplate.paymentmessagetype" (onChange)="DoValidCheck()"></p-selectbutton>
            </div>
            @if (emailtemplate.paymentmessagetype != 'NONE') {
              <div class="field mb-4 col-12">
                <textarea pInputText type="text" [(ngModel)]="emailtemplate.paymentmessage" style="width:100%; height: 100px;" [ngStyle]="{'border-color': (paymentmessageValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()"></textarea>
              </div>
            }
            @if (!paymentmessageValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Payment message.</div>
            }
            <div class="field mb-4 col-12">
              <label for="venueclosingstartdate">Show customer services</label>
              <p-selectbutton [style]="{'width': '450px'}" [options]="YesNo" [(ngModel)]="emailtemplate.showcustomerservices" (onChange)="DoValidCheck()"></p-selectbutton>
            </div>
            <div class="field mb-4 col-12">
              <label for="venueclosingstartdate">Show Logo</label>
              <p-selectbutton [style]="{'width': '450px'}" [options]="YesNo" [(ngModel)]="emailtemplate.showlogo" (onChange)="DoValidCheck()"></p-selectbutton>
            </div>
            <div class="field mb-4 col-12">
              <label for="venueclosingstartdate">Show End Time</label>
              <p-selectbutton [style]="{'width': '450px'}" [options]="YesNo" [(ngModel)]="emailtemplate.showendtime" (onChange)="DoValidCheck()"></p-selectbutton>
            </div>
            @if (emailtemplate.showcustomerservices) {
              <div class="surface-card p-4 shadow-2 border-round" style="width:100%">
                <div class="field mb-5 col-12">
                  <label for="venueclosingstartdate">Show email</label>
                  <p-selectbutton [style]="{'width': '450px'}" [options]="YesNo" [(ngModel)]="emailtemplate.showemail"  (onChange)="customerServiceChanged()"></p-selectbutton>
                </div>
                @if (emailtemplate.showemail) {
                  <div class="field mb-5 col-12">
                    <input [(ngModel)]="emailtemplate.emailtext" id="classname" type="text" [ngStyle]="{'border-color': (emailtextValid==false) ? '#FF0000':''}" pInputText (keyup)="DoValidCheck()">
                  </div>
                }
                @if (!emailtextValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                }
                <div class="field mb-5 col-12">
                  <label for="venueclosingstartdate">Show phone number</label>
                  <p-selectbutton [style]="{'width': '450px'}" [options]="YesNo" [(ngModel)]="emailtemplate.showphone"  (onChange)="customerServiceChanged()"></p-selectbutton>
                </div>
                @if (emailtemplate.showphone) {
                  <div class="field mb-5 col-12">
                    <input [(ngModel)]="emailtemplate.phonetext" id="classname" type="text" [ngStyle]="{'border-color': (phonetextValid==false) ? '#FF0000':''}" pInputText (keyup)="DoValidCheck()">
                  </div>
                }
                @if (!phonetextValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Phone number.</div>
                }
              </div>
            }
            <!-- Desktop only. On a phone they move below the preview, at the end of the page. -->
            @if (!isMobile) {
              <div class="col-12">
                <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                Save Changes</button>
                &nbsp;
                <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                  <span class="pi pi-times" style="margin-right:8px;"></span>
                Cancel</button>
              </div>
            }
          </div>
        </div>
        @if (!isMobile) {
          <div class="surface-card p-4 shadow-2 border-round cf-col" style="width: 49%; float:left; margin-left:1%;font-size: 17px;margin-bottom:20px;">
            <span style="margin-bottom:20px;">Selectable Fields (Please drag the field you want into section on the left in the position you would it to be)</span>
            <div>
              @for (c of ContArray; track c) {
                <div draggable="true" id="{{c.fieldname}}" style="width: 167px;margin-right: 10px;border-radius: 30px;text-align: center;margin-bottom: 5px; background-color: #22C5D7; color:white;padding:10px;margin:5px; float: left;">
                  {{c.fieldname}}
                </div>
              }
            </div>
          </div>
        }
        <div class="surface-card p-4 shadow-2 border-round cf-col cf-preview" style="width: 49%; float:left; margin-left:1%;font-size: 17px;">
          <span style="font-weight:bold;">Preview</span>
          <br />
          @if (emailtemplate.showlogo === true) {
            <div style="text-align: center;">
              <img width="{{PublicImageWidth}}" height="{{PublicImageHeight}}" src="{{PublicImageURL}}" />
            </div>
          }
          <div style="margin:20px;">
            <div [innerHTML]="processMessage(emailtemplate.message)| safe: 'html'"></div>
          </div>
          <hr />
          @if (emailtemplate.paymentmessagetype != 'NONE') {
            <div style="margin:20px;">
              <div style="font-weight: bold;margin-bottom: 10px;">Payment message</div>
              <div [innerHTML]="emailtemplate.paymentmessage"></div>
              @if (emailtemplate.paymentmessagetype == 'TEXTONLYOB') {
                <div style="text-align:right;">
                  <button pButton pRipple type="button" class="p-button p-element p-button-info w-auto mt-3">
                    <span class="pi pi-pound" style="margin-right:8px;"></span>
                  Pay {{CurrencySymbol}}22.54</button>
                </div>
              }
            </div>
          }
          @if (emailtemplate.showcustomerservices) {
            <div  style="margin:20px;">
              <div style="font-weight: bold;margin-bottom: 10px;">Customer Services</div>
              @if (emailtemplate.showemail) {
                <div style="margin:20px;">
                  <div style="font-weight: bold;margin-bottom: 10px;">Email</div>
                  {{emailtemplate.emailtext}}
                </div>
              }
              @if (emailtemplate.showphone) {
                <div style="margin:20px;">
                  <div style="font-weight: bold;margin-bottom: 10px;">Phone</div>
                  {{emailtemplate.phonetext}}
                </div>
              }
              <div  style="margin:20px;">
                <div style="font-weight: bold;margin-bottom: 10px;">Terms & Conditions</div>
                <a href="#">Click here to view Terms and Conditions</a>
              </div>
            </div>
          }
        </div>
        <!-- On a phone Save and Cancel come last, under the preview, so the whole template can be
        checked before saving. -->
        @if (isMobile) {
          <div class="cf-col cf-page-actions">
            <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="updateData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
            Save Changes</button>
            <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="returnToList()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
            Cancel</button>
          </div>
        }
      </div>
    </div>
  }